module.exports = __webpack_public_path__ + "media/packs/images/flags/GB-119f91b54b944abd0583dcc9720374bb.svg";